export default {
      id: "group-5-usage",
      viewBox: "0 0 26 27",
      url: __webpack_public_path__ + "sprite.svg#group-5",
      toString: function () {
        return this.url;
      }
    }